import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Table, Alert, Button,
} from 'antd';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';

import PageContent from '../../components/Layout/PageContent';
import { webCardsGet, webCardSort } from '../../redux/actions/webCards';
import { loadingSelector, dataListSelector, errorsSelector } from '../../redux/selectors/webCards';
import { webCardColumns } from './constants';
import './WebCards.css';

const WebCardsList = () => {
  const dispatch = useDispatch();
  const loading = useSelector(loadingSelector);
  const errors = useSelector(errorsSelector);
  const webCardsList = useSelector(dataListSelector);

  useEffect(() => {
    dispatch(webCardsGet());
  }, [dispatch]);

  const DraggableContainer = (props) => (
    <SortableContainer
      useDragHandle
      helperClass="row-dragging"
      onSortEnd={({ oldIndex, newIndex }) => dispatch(webCardSort(oldIndex, newIndex))}
      {...props}
    />
  );

  return (
    <PageContent title="Current Web Cards" breadcrumb={['Web', 'Hero Cards']} loading={loading}>
      <div className="web-cards__add_button">
        <Link to="/cards/create">
          <Button type="secondary" size="large">CREATE NEW</Button>
        </Link>
      </div>
      {errors && <Alert message={errors} type="error" showIcon closable />}
      <Table
        columns={webCardColumns(dispatch)}
        dataSource={webCardsList}
        pagination={false}
        rowKey="id"
        components={{
          body: {
            wrapper: DraggableContainer,
            row: DraggableBodyRow(webCardsList),
          },
        }}
      />
    </PageContent>
  );
};

export default WebCardsList;

const DraggableBodyRow = (webCardsList) => ({ ...props }) => {
  const index = webCardsList.findIndex(({ id }) => `${id}` === `${props['data-row-key']}`);
  return <SortableItem index={index} {...props} />;
};

const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
